module.exports = __webpack_public_path__ + "img/image_big_logo.70ac9626.png";